const key = {};

export { key };
